import { FORM_VALIDATIONS_ERRORS, GET_CUSTOMER_LIST_BEGIN, GET_CUSTOMER_LIST_SUCCESS, GET_DASHBOARD_SIDEBAR_LINKS_BEGIN, GET_DASHBOARD_SIDEBAR_LINKS_SUCCESS, GET_FORM_VALUES, GET_INSURENCE_COMPANIES, GET_NOTES_BEGIN, GET_NOTES_SUCCESS, GET_SELECTED_PATIENT, GET_VALUES_OF_REFFERED, GET_VALUES_OF_REFFERED_ADJUSTER_ID, OPEN_TAB, RESET_FORM_VALUES } from "./actions"

const reducers = (state, action) => {
    switch (action.type) {
        case OPEN_TAB: {
            return {
                ...state,
                activeTab: action.payload
            }
        }
        case GET_CUSTOMER_LIST_BEGIN:
            return { ...state, isLoading: true };
        case GET_CUSTOMER_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                customerList: action.payload?.length ? action.payload[0] : {},
            };
        case GET_DASHBOARD_SIDEBAR_LINKS_BEGIN:
            return { ...state, isLoading: true };
        case GET_DASHBOARD_SIDEBAR_LINKS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                dashboardSidebarList: action.payload.companies,
            };
        case GET_NOTES_BEGIN:
            return { ...state, isLoading: true };
        case GET_NOTES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                notes: action.payload,
            };
        case GET_FORM_VALUES:
            return {
                ...state,
                formDataValues: action.payload
            }
        case RESET_FORM_VALUES:
            return {
                ...state,
                formDataValues:{
                    patientInfo:{},
                    employeeInfo:{},
                    referredByInfo:{
                    },
                    proceduresInfo:[{
                    bodyParts:"",
                    bodySide:"",
                    procedure:"",
                    diagnosisRuleOut1:"",
                    diagnosisRuleOut2:""
                    }],
                    specialInstruction:{},
                }
            }
        case GET_VALUES_OF_REFFERED:
            return {
                ...state,
                insurenceId: action.payload,
            }
        case GET_VALUES_OF_REFFERED_ADJUSTER_ID:
            return {
                ...state,
                adjusterId: action.payload,
            }
        case GET_INSURENCE_COMPANIES:
            return {
                ...state,
                insuranceCompanies: action.payload
            }          
            case GET_SELECTED_PATIENT:
                return {
                    ...state,
                    selectedPatient:action.payload
                }
            case FORM_VALIDATIONS_ERRORS:
                return {
                    ...state,
                    errors:action.payload
            }
        default:
            return state;
    }

}

export default reducers